import type { AnchoredPlacement } from '../anchored-overlay';

/** Edge of the panel that faces its trigger, which is where the gap has to be reserved. */
export type DisclosureFlyoutGapEdge = 'inline-start' | 'inline-end' | 'top' | 'bottom';

const GAP_EDGE_BY_PLACEMENT: Record<AnchoredPlacement, DisclosureFlyoutGapEdge> = {
  'inline-end-top': 'inline-start',
  'inline-end-bottom': 'inline-start',
  'inline-start-top': 'inline-end',
  'inline-start-bottom': 'inline-end',
  'bottom-start': 'top',
  'bottom-end': 'top',
  'top-start': 'bottom',
  'top-end': 'bottom',
};

export function toGapEdge(placement: AnchoredPlacement): DisclosureFlyoutGapEdge {
  return GAP_EDGE_BY_PLACEMENT[placement];
}
